/* PureNADH · Learn experience · behaviour (generated) */
(function(){
'use strict';
var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var $  = function(s,c){return (c||document).querySelector(s);};
var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
var store = {
  get:function(k){try{return JSON.parse(localStorage.getItem('pnadh_'+k));}catch(e){return null;}},
  set:function(k,v){try{localStorage.setItem('pnadh_'+k,JSON.stringify(v));}catch(e){}}
};

/* ---------- analytics ---------- fires to GTM/GA4 dataLayer, gtag, Klaviyo, + a custom event */
function track(name,data){
  data=data||{};
  try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:'pnadh_'+name},data)); }catch(e){}
  try{ if(typeof window.gtag==='function') window.gtag('event','pnadh_'+name,data); }catch(e){}
  try{ var k=window._learnq=window._learnq||[]; k.push(['track','Learn: '+name,data]); }catch(e){}
  try{ window.dispatchEvent(new CustomEvent('pnadh:'+name,{detail:data})); }catch(e){}
}

/* ---------- progress / completion / gamification ---------- */
var TOTAL = $$('.lesson[data-chapter]').length || 9; // dynamic chapter count (finish is not a .lesson)
var done = store.get('done') || {};
var energyMini = $('#energyMini'), progressPct = $('#progressPct');
var segTrack=$('#segTrack');
if(segTrack){ for(var si=0;si<TOTAL;si++){ segTrack.appendChild(document.createElement('i')); } }
function pctDone(){var n=0;for(var i=1;i<=TOTAL;i++){if(done[i])n++;}return Math.round(n/TOTAL*100);}
function paintProgress(){
  var p = pctDone();
  if(energyMini) energyMini.style.setProperty('--p', p+'%');
  progressPct.textContent = p+'%';
  $$('#segTrack i').forEach(function(sg,ix){ sg.classList.toggle('done', !!done[ix+1]); });
  $$('#chapList .chap').forEach(function(c){
    var id=c.getAttribute('data-ch');
    c.classList.toggle('done', !!done[id]);
  });
  var arc=$('#badgeArc'); if(arc){var C=327;arc.style.strokeDashoffset=C-(C*p/100);}
  var bp=$('#badgePct'); if(bp) bp.textContent=p+'%';
  var nd=0;for(var i=1;i<=TOTAL;i++){if(done[i])nd++;}
  var sc=$('#statChapters'); if(sc) sc.textContent=nd;
  if(p>=100 && !store.get('celebrated')){ celebrate(); store.set('celebrated',true); track('learn_complete',{}); }
}
/* ---------- build chapter list ---------- */
var chapList=$('#chapList');
$$('.lesson[data-chapter]').forEach(function(sec){
  var ch=sec.getAttribute('data-chapter');
  if(ch==='0'||ch==='10') return;
  var li=document.createElement('li');
  var a=document.createElement('a');
  a.className='chap'; a.href='#'+sec.id; a.setAttribute('data-ch',ch);
  a.innerHTML='<span class="ring"></span><span class="ct">'+sec.getAttribute('data-title')+
    '<span class="ck">'+sec.getAttribute('data-kicker')+'</span></span>';
  a.addEventListener('click',function(ev){ ev.preventDefault(); jumpToChapter(ch); closeMenu(); });
  li.appendChild(a); chapList.appendChild(li);
});

/* ---------- chapter menu ---------- */
var menuBtn=$('#menuBtn'), chapters=$('#chapters'), scrim=$('#scrim');
function openMenu(){chapters.classList.add('open');scrim.classList.add('show');menuBtn.setAttribute('aria-expanded','true');}
function closeMenu(){chapters.classList.remove('open');scrim.classList.remove('show');menuBtn.setAttribute('aria-expanded','false');}
menuBtn.addEventListener('click',function(){chapters.classList.contains('open')?closeMenu():openMenu();});
scrim.addEventListener('click',closeMenu);
$$('[data-close]').forEach(function(b){b.addEventListener('click',closeMenu);});
document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&chapters.classList.contains('open')){closeMenu();menuBtn.focus();} });

/* ---------- scroll rail + active chapter + hide-on-scroll ---------- */
var railbar=$('#railbar'), topbar=$('#topbar'), lastY=0;
function onScroll(){
  topbar.style.transform='translateY(0)'; // always visible (holds the close button)
  // (the progress rail now reflects step progress, set in goToStep)
}
window.addEventListener('scroll',onScroll,{passive:true});

/* ---------- reveal + per-lesson activation via IntersectionObserver ---------- */
var io=new IntersectionObserver(function(entries){
  entries.forEach(function(e){
    if(e.isIntersecting){ e.target.classList.add('in'); fireWatch(e.target); }
  });
},{threshold:0.18, rootMargin:'0px 0px -8% 0px'});
$$('.reveal,.fade,.scale-in,[data-watch]').forEach(function(el){io.observe(el);});

/* fire interactive widgets once when scrolled into view */
var fired={};
function fireWatch(el){
  var key=el.getAttribute('data-watch'); if(!key||fired[key])return; fired[key]=true;
  if(W[key]) W[key](el);
}
var W={}; // widget initialisers keyed by data-watch

/* ============================================================
   LESSON 1 · effort/energy gap, name reveal, engine
============================================================ */
W.gap=function(el){
  $$('.gap-fill',el).forEach(function(f){f.style.width=f.getAttribute('data-w')+'%';});
  $$('.val',el).forEach(function(v){
    var target=parseInt(v.textContent.replace(/\D/g,''),10);
    if(!target||RM) return;
    var pre=v.textContent.indexOf('~')>-1?'~':'', t0=null;
    (function tick(ts){ if(!t0)t0=ts||performance.now(); var p=Math.min(1,((ts||performance.now())-t0)/1200);
      v.textContent=pre+Math.round(target*(p*(2-p)))+'%';
      if(p<1)requestAnimationFrame(tick); })();
  });
};
W.name=function(el){
  var t=setTimeout(function(){el.classList.add('collapsed');}, RM?0:2600);
  el.addEventListener('click',function(){ clearTimeout(t); el.classList.add('collapsed'); },{once:true});
};

var engine=$('#engine'), engBtn=$('#engineBtn'), engStatus=$('#engineStatus'), engGauge=$('#engGauge'),
    engPart=$('#engPart'), engSlot=$('#engSlot'), pistons=$$('#pistons .eng-piston'), engineRunning=false, pistonTimer;
function setEngine(on){
  engineRunning=on;
  engine.classList.toggle('running',on);
  engPart.style.opacity=on?1:0; engSlot.style.opacity=on?0:1;
  engStatus.textContent = on ? 'Running smoothly. That’s the missing piece in place.' : 'Best fuel in the world. But the engine is missing a part.';
  engStatus.classList.toggle('on',on);
  engBtn.textContent = on ? 'Remove the piece' : 'Add the missing piece';
  if(engGauge) engGauge.classList.toggle('full',on);
  clearInterval(pistonTimer);
  if(on && !RM){
    var up=false;
    pistonTimer=setInterval(function(){ up=!up;
      pistons.forEach(function(p,i){ p.style.transform='translateY('+((up?(i%2?-6:6):(i%2?6:-6)))+'px)'; });
    },140);
  } else { pistons.forEach(function(p){p.style.transform='none';}); }
}
if(engBtn) engBtn.addEventListener('click',function(){setEngine(!engineRunning);});
/* auto-demonstrate when the engine scrolls into view (so users see the payoff
   without having to discover a hidden tap). They can still Replay. */
W.engineDemo=function(){ if(!RM) setTimeout(function(){ if(!engineRunning) setEngine(true); }, 600); };

/* LESSON 2 age-decline widget removed 2026-09-02 (BANNED #2: NADH declines with age). Do not bring back. */

/* ============================================================
   LESSON 7 · molecule degradation, label arrives, shield
============================================================ */
var molNodes=$$('#molNodes .mol-node'), molBonds=$$('#molBonds .mol-bond'),
    molStatus=$('#molStatus'), molReset=$('#molReset'), threats=$$('.threat'), molBroken=false,
    molFlash=$('#molFlash'), molSvgEl=$('#molSvg');
var threatColor=['rgba(59,111,212,.45)','rgba(246,198,111,.6)','rgba(224,101,79,.45)','rgba(159,180,212,.5)'];
var threatMsg=[
  'Moisture breaks the bonds, and the molecule starts to fall apart.',
  'Light degrades it, and pieces drift away.',
  'Heat unravels the structure, and activity is lost.',
  'Oxygen and stomach acid finish the job, and what’s left may do nothing.'
];
function breakMolecule(idx){
  if(molBroken) return; molBroken=true;
  threats.forEach(function(t){t.classList.remove('hint');});
  threats[idx].classList.add('fired');
  if(molFlash&&!RM){ molFlash.style.background=threatColor[idx]; molFlash.classList.remove('go'); void molFlash.offsetWidth; molFlash.classList.add('go'); }
  if(molSvgEl&&!RM&&idx===2){ molSvgEl.classList.remove('shake'); void molSvgEl.offsetWidth; molSvgEl.classList.add('shake'); }
  var av=$('#arrivesVal'); if(av){ av.textContent='a fraction'; av.parentElement.classList.add('hit'); }
  molBonds.forEach(function(b){b.style.opacity=0;});
  var offs=[[-60,-50],[60,-50],[-60,50],[60,50]];
  $$('#molNodes .mol-node[data-n]').forEach(function(n){
    var d=n.getAttribute('data-n'); if(d==='c'){n.style.opacity=.3;return;}
    var o=offs[+d]; n.style.transform='translate('+o[0]+'px,'+o[1]+'px)'; n.style.opacity=.35;
  });
  molStatus.textContent=threatMsg[idx]; molStatus.classList.add('broken');
  molReset.hidden=false;
}
threats.forEach(function(t,i){ t.addEventListener('click',function(){breakMolecule(+t.getAttribute('data-threat'));}); });
/* gentle one-time hint so users notice the threats are tappable */
W.molecule=function(){ if(RM||molBroken) return; setTimeout(function(){ if(molBroken)return; threats.forEach(function(t){t.classList.add('hint');}); setTimeout(function(){threats.forEach(function(t){t.classList.remove('hint');});},3400); }, 800); };
if(molReset) molReset.addEventListener('click',function(){
  molBroken=false; molReset.hidden=true; molStatus.classList.remove('broken');
  molStatus.textContent='Right now it’s intact, exactly how your cells can use it.';
  molBonds.forEach(function(b){b.style.opacity=1;});
  $$('#molNodes .mol-node').forEach(function(n){n.style.transform='none';n.style.opacity=1;});
  threats.forEach(function(t){t.classList.remove('fired');});
  var av2=$('#arrivesVal'); if(av2){ av2.textContent='?'; av2.parentElement.classList.remove('hit'); }
  if(!RM){ threats.forEach(function(t){t.classList.add('hint');}); setTimeout(function(){threats.forEach(function(t){t.classList.remove('hint');});},1800); }
});

/* ============================================================
   LESSON 8 / 9 · spec + expectation staggers
============================================================ */
W.specs=function(el){ $$('.spec',el).forEach(function(s,i){ setTimeout(function(){s.classList.add('in');}, RM?0:i*150); }); };
W.expect=function(el){
  el.classList.add('drawn');
  $$('.expect-row',el).forEach(function(r,i){ setTimeout(function(){r.classList.add('in');}, RM?0:i*220); });
};

/* ============================================================
   Explore-more topic cards (one open at a time, tracked per topic)
============================================================ */
$$('.topic').forEach(function(t){
  t.addEventListener('click',function(){
    var wasOpen=t.classList.contains('open');
    $$('.topic.open').forEach(function(o){ o.classList.remove('open'); o.setAttribute('aria-expanded','false'); });
    if(!wasOpen){
      t.classList.add('open'); t.setAttribute('aria-expanded','true');
      track('learn_topic',{topic:t.getAttribute('data-topic')});
    }
  });
});

/* ============================================================
   FAQ accordion
============================================================ */
$$('.qa button').forEach(function(b){
  b.addEventListener('click',function(){
    var qa=b.parentElement, ans=$('.ans',qa), open=qa.classList.toggle('open');
    b.setAttribute('aria-expanded',open);
    ans.style.maxHeight= open ? ans.scrollHeight+'px' : 0;
  });
});

/* ============================================================
   email capture (front-end only; wire to Klaviyo/Shopify on port)
============================================================ */
var CFG=window.PNADH_CFG||{};
var offerForm=$('#offerForm');
if(offerForm) offerForm.addEventListener('submit',function(e){
  e.preventDefault();
  var input=offerForm.querySelector('input[type=email]'); var btn=offerForm.querySelector('button');
  var email=(input.value||'').trim(); if(!email) return;
  btn.disabled=true; var label=btn.textContent; btn.textContent='Sending…';
  store.set('lead',true); track('learn_lead',{});
  function ok(sent){
    offerForm.hidden=true; var su=$('.offer-success'); if(!su) return;
    su.hidden=false;
    if(!sent){ /* Klaviyo not configured: no email can go out; say so honestly */
      var l=su.querySelector('.offer-lead'); if(l) l.textContent='✓ Done. We could not send the code right now. Email support@purenadh.com and we will send it by hand.';
    }
  }
  function fail(){ btn.disabled=false; btn.textContent=label; var m=offerForm.querySelector('.offer-micro'); if(m){m.textContent='Something went wrong. Please try again.';m.style.color='#f6c66f';} }
  if(!CFG.klaviyoCompany||!CFG.klaviyoList){ ok(false); return; } // no config: still show the code (no email goes out)
  /* 2026-09-14: event "Finished NADH Series" pokrece Klaviyo flow #06 (15% kod, radi i za profile koji su vec na listi); lista = consent */
  fetch('https://a.klaviyo.com/client/events/?company_id='+encodeURIComponent(CFG.klaviyoCompany),{
    method:'POST',
    headers:{'Content-Type':'application/json','revision':'2024-10-15'},
    body:JSON.stringify({data:{type:'event',attributes:{
      properties:{source:'learn-v2',chapters:6},
      metric:{data:{type:'metric',attributes:{name:'Finished NADH Series'}}},
      profile:{data:{type:'profile',attributes:{email:email}}}
    }}})
  }).catch(function(){});
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(CFG.klaviyoCompany),{
    method:'POST',
    headers:{'Content-Type':'application/json','revision':'2024-10-15'},
    body:JSON.stringify({data:{type:'subscription',attributes:{
      custom_source:'NADH Learn Offer',
      profile:{data:{type:'profile',attributes:{email:email}}}
    },relationships:{list:{data:{type:'list',id:CFG.klaviyoList}}}}})
  }).then(function(r){ if(r.ok||r.status===202){ok(true);} else {fail();} }).catch(fail);
});
/* returning lead: they already gave their email, show the code straight away */
if(offerForm && store.get('lead')){
  offerForm.hidden=true;
  var su0=$('.offer-success');
  if(su0){ su0.hidden=false; var l0=su0.querySelector('.offer-lead'); if(l0) l0.textContent='Welcome back. Your personal code is in your inbox.'; }
}

/* ============================================================
   confetti on completion
============================================================ */
function celebrate(){
  if(RM) return; var cv=$('#confetti'); if(!cv) return;
  var ctx=cv.getContext('2d'); function size(){cv.width=cv.offsetWidth;cv.height=cv.offsetHeight;} size();
  var cols=['#6891CC','#35719F','#043C54','#2faa6a','#CEE5F2']; var P=[];
  for(var i=0;i<120;i++){P.push({x:Math.random()*cv.width,y:-20-Math.random()*cv.height,
    r:3+Math.random()*5,vy:2+Math.random()*3,vx:-1+Math.random()*2,c:cols[i%cols.length],a:Math.random()*6});}
  var frames=0;
  (function loop(){ ctx.clearRect(0,0,cv.width,cv.height);
    P.forEach(function(p){p.y+=p.vy;p.x+=p.vx;p.a+=0.1;
      ctx.save();ctx.translate(p.x,p.y);ctx.rotate(p.a);ctx.fillStyle=p.c;ctx.fillRect(-p.r,-p.r,p.r*2,p.r*1.2);ctx.restore();});
    frames++; if(frames<220)requestAnimationFrame(loop); else ctx.clearRect(0,0,cv.width,cv.height);
  })();
}

/* ============================================================
   hero particle field (lightweight energy source)
============================================================ */
(function(){
  var cv=$('#heroField'); if(!cv||RM) return;
  var ctx=cv.getContext('2d'), W2,H2, pts=[];
  function size(){W2=cv.width=cv.offsetWidth;H2=cv.height=cv.offsetHeight;
    pts=[]; var n=Math.min(70,Math.floor(W2/16));
    for(var i=0;i<n;i++)pts.push({x:Math.random()*W2,y:Math.random()*H2,vx:-.3+Math.random()*.6,vy:-.3+Math.random()*.6,r:.6+Math.random()*1.6});}
  size(); window.addEventListener('resize',size);
  // pause the loop when the hero scrolls out of view (saves battery / CPU)
  var heroVisible=true;
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){ heroVisible=es[0].isIntersecting; if(heroVisible)requestAnimationFrame(loop); },{threshold:0}).observe(cv);
  }
  document.addEventListener('visibilitychange',function(){ if(!document.hidden&&heroVisible)requestAnimationFrame(loop); });
  var cx,cy; function center(){cx=W2/2;cy=H2*0.32;}
  function loop(){ if(!heroVisible||document.hidden)return; center(); ctx.clearRect(0,0,W2,H2);
    // glow source
    var g=ctx.createRadialGradient(cx,cy,0,cx,cy,140);
    g.addColorStop(0,'rgba(104,145,204,.18)');g.addColorStop(1,'rgba(104,145,204,0)');
    ctx.fillStyle=g; ctx.beginPath();ctx.arc(cx,cy,140,0,7);ctx.fill();
    pts.forEach(function(p){p.x+=p.vx;p.y+=p.vy;
      if(p.x<0||p.x>W2)p.vx*=-1; if(p.y<0||p.y>H2)p.vy*=-1;
      var dx=p.x-cx,dy=p.y-cy,d=Math.sqrt(dx*dx+dy*dy);
      var alpha=Math.max(.08,1-d/420);
      ctx.fillStyle='rgba(53,113,159,'+(alpha*.5)+')'; ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,7);ctx.fill();
      if(d<150){ctx.strokeStyle='rgba(4,60,84,'+(0.08*(1-d/150))+')';ctx.beginPath();ctx.moveTo(p.x,p.y);ctx.lineTo(cx,cy);ctx.stroke();}
    });
    requestAnimationFrame(loop);
  }
  loop();
})();

/* CTA click tracking */
$$('[data-cta]').forEach(function(b){
  b.addEventListener('click',function(){ track('learn_cta',{cta:b.getAttribute('data-cta')}); });
});

/* ============================================================
   STEP MODE · one chapter per screen, tap "Continue" to advance
   (chunked, learner-paced; scroll within a chapter, tap between)
============================================================ */
var mainEl=$('#main'), steps=[], stepIndex=0, TOTAL_STEPS=0;
function stepChapter(s){ var c=s&&s.querySelector('[data-chapter]'); return c?+c.getAttribute('data-chapter'):null; }
(function buildSteps(){
  if(!mainEl) return;
  var kids=$$('#main > *'), pending=null, cur=null;
  function add(){ var d=document.createElement('section'); d.className='pnadh-step'; steps.push(d); cur=d; return d; }
  kids.forEach(function(node){
    if(node.classList.contains('section-divider')){ pending=node; return; } // attach to next chapter
    var isStepStart = (node.classList.contains('lesson') && node.hasAttribute('data-chapter'))
                   || node.classList.contains('capture') || node.classList.contains('finish');
    if(isStepStart){ add(); if(pending){cur.appendChild(pending);pending=null;} cur.appendChild(node); }
    else if(cur){ cur.appendChild(node); }   // faq + footer ride along on the final step
    else { add(); cur.appendChild(node); }
  });
  steps.forEach(function(s){ mainEl.appendChild(s); });
  TOTAL_STEPS=steps.length;
  if(steps[0]) steps[0].classList.add('active'); // initial (still hidden until experience opens)
})();

/* one fixed bottom bar so "Continue" is ALWAYS reachable (no scroll-hunting) */
var stepBar=document.createElement('div'); stepBar.className='pnadh-stepbar';
var _nextEl=document.createElement('span'); _nextEl.className='pnadh-next';
var _back=document.createElement('button'); _back.type='button'; _back.className='pnadh-back'; _back.innerHTML='&larr; Back';
_back.addEventListener('click',function(){ goToStep(stepIndex-1); });
var _cont=document.createElement('button'); _cont.type='button'; _cont.className='btn btn-amber pnadh-continue'; _cont.innerHTML='Continue &rarr;';
_cont.addEventListener('click',function(){ goToStep(stepIndex+1); });
stepBar.appendChild(_nextEl); stepBar.appendChild(_back); stepBar.appendChild(_cont);
var pnadhAnnounce=document.createElement('div'); pnadhAnnounce.className='sr-only'; pnadhAnnounce.setAttribute('aria-live','polite');
(function(){ var e=document.getElementById('pnadhExperience')||document.body; e.appendChild(stepBar); e.appendChild(pnadhAnnounce); })();

function activateStep(s){
  $$('.reveal,.fade,.scale-in,[data-watch]',s).forEach(function(el){
    if(el.getBoundingClientRect().top < window.innerHeight*1.25){ el.classList.add('in'); fireWatch(el); }
  });
}
function goToStep(i){
  if(i<0||i>=TOTAL_STEPS||!steps.length) return;
  var dir = i>=stepIndex ? 'fwd' : 'bwd';
  if(steps[stepIndex]) steps[stepIndex].classList.remove('active','fwd','bwd');
  stepIndex=i; var s=steps[i]; s.classList.remove('fwd','bwd'); s.classList.add('active',dir);
  window.scrollTo(0,0);
  if(expEl && expEl.scrollTo) expEl.scrollTo(0,0); // the experience is a fixed overlay with its own scroll
  /* chapters BEHIND you count as done; 100% lands exactly on the finish ring */
  for(var k=0;k<i;k++){ var ch=stepChapter(steps[k]); if(ch>=1&&ch<=TOTAL) done[ch]=true; }
  store.set('done',done); store.set('lastStep',i); paintProgress();
  if(railbar) railbar.style.setProperty('--scroll', Math.round(i/(TOTAL_STEPS-1||1)*100)+'%');
  var cur=stepChapter(s);
  $$('#chapList .chap').forEach(function(c){ c.classList.toggle('active', cur!=null && +c.getAttribute('data-ch')===cur); });
  $$('#segTrack i').forEach(function(sg,ix){ sg.classList.toggle('now', cur!=null && cur<=TOTAL && ix+1===cur); });
  var isChapter=(cur!=null && cur<=TOTAL);
  if(isChapter) track('learn_chapter',{chapter:cur, step:i});
  var _h=s.querySelector('h2'); if(pnadhAnnounce) pnadhAnnounce.textContent=(isChapter?('Chapter '+cur+' of '+TOTAL+'. '):'')+(_h?_h.textContent:'');
  /* next-up teaser keeps the loop open */
  if(_nextEl){ var ns=steps[i+1], nt=''; if(ns){ var c2=ns.querySelector('[data-chapter]'); if(c2){ var nc=+c2.getAttribute('data-chapter'); nt='Next: '+(nc===99?'your reward':c2.getAttribute('data-title')); } } _nextEl.textContent=nt; }
  /* move focus to the new step: resets SR reading order + clears the lingering button focus ring */
  s.setAttribute('tabindex','-1'); try{ s.focus({preventScroll:true}); }catch(e){}
  // fixed nav bar: visible on every chapter step, hidden on the final (it has its own CTA)
  var last=(i>=TOTAL_STEPS-1);
  stepBar.classList.toggle('show', !last);
  _back.style.visibility = (i>0) ? 'visible' : 'hidden';
  requestAnimationFrame(function(){ activateStep(s); });
}
function jumpToChapter(ch){
  for(var i=0;i<steps.length;i++){ if(stepChapter(steps[i])===+ch){ goToStep(i); return; } }
}

/* ---------- hide floating chat/launcher widgets while the experience is open ----------
   Theme chat bubbles (Shopify Inbox, WhatsApp, Tidio, Channel.io, etc.) inject
   their own fixed, high-z, bottom-corner nodes that we can't target by a known
   selector. Detect them by position instead, hide on open, restore on close. */
var pnadhHiddenWidgets=[];
function pnadhHideWidgets(){
  try{
    var vw=window.innerWidth, vh=window.innerHeight;
    Array.prototype.slice.call(document.body.children).forEach(function(el){
      if(!el || el.nodeType!==1) return;
      if(el.closest && el.closest('.pnadh-learn')) return;
      if(el.classList && el.classList.contains('pnadh-stepbar')) return;
      var s; try{ s=getComputedStyle(el); }catch(e){ return; }
      if(s.position!=='fixed' || s.display==='none') return;
      var z=parseInt(s.zIndex,10)||0;
      var r=el.getBoundingClientRect();
      if(r.width===0||r.height===0) return;
      var cornerLauncher = r.bottom>vh-180 && r.right>vw-180 && r.width<220 && r.height<220 && z>=5;
      var fullChatPanel = z>=2147483000; // chat SDKs often use max int z-index
      if(cornerLauncher || fullChatPanel){
        pnadhHiddenWidgets.push([el, el.style.getPropertyValue('display'), el.style.getPropertyPriority('display')]);
        el.style.setProperty('display','none','important');
      }
    });
  }catch(e){}
}
function pnadhRestoreWidgets(){
  pnadhHiddenWidgets.forEach(function(p){
    if(p[1]) p[0].style.setProperty('display',p[1],p[2]); else p[0].style.removeProperty('display');
  });
  pnadhHiddenWidgets=[];
}

/* ---------- open / close the full-screen experience ---------- */
var root=document.documentElement, expEl=$('#pnadhExperience');
function openExperience(keepProgress){
  if(keepProgress!==true){ done={}; store.set('done',done); store.set('celebrated',false); } // fresh start: progress reflects this session
  root.classList.add('pnadh-open');
  closeMenu();
  pnadhHideWidgets();
  setTimeout(pnadhHideWidgets,800);   // catch chat widgets that load late
  setTimeout(pnadhHideWidgets,2500);
  goToStep(0);
  if(!history.state || !history.state.pnadhOpen){ try{ history.pushState({pnadhOpen:true},''); }catch(e){} }
  track('learn_open',{});
  if(expEl){ expEl.setAttribute('tabindex','-1'); expEl.focus({preventScroll:true}); }
}
function closeExperience(fromPop){
  root.classList.remove('pnadh-open');
  closeMenu();
  pnadhRestoreWidgets();
  if(!fromPop){ try{ if(history.state && history.state.pnadhOpen) history.back(); }catch(e){} }
  var l=$('#pnadhLanding'); if(l){ l.scrollIntoView(); } else { window.scrollTo(0,0); }
}
$$('[data-open]').forEach(function(b){ b.addEventListener('click',openExperience); });
var closeBtn=$('#pnadhClose'); if(closeBtn) closeBtn.addEventListener('click',function(){ closeExperience(false); });
document.addEventListener('keydown',function(e){
  if(e.key==='Escape' && root.classList.contains('pnadh-open') && !chapters.classList.contains('open')) closeExperience(false);
});
/* mobile Back button closes the series instead of leaving the page */
window.addEventListener('popstate',function(){ if(root.classList.contains('pnadh-open')) closeExperience(true); });
/* in-experience nav links → jump to a step */
var seeProg=$('.chapters [href="#finish"]'); if(seeProg) seeProg.addEventListener('click',function(e){ e.preventDefault(); goToStep(TOTAL_STEPS-1); closeMenu(); });
/* only the explicit "Start over" link (and the footer link) restart; product links keep their hrefs */
$$('.pnadh-restart, footer a[href="#main"]').forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault(); goToStep(0); }); });
/* "Explore more topics" scrolls within the finish step without adding a history entry */
var exploreJump=$('.finish-cta a[href="#explore"]');
if(exploreJump) exploreJump.addEventListener('click',function(e){ e.preventDefault(); var x=$('#explore'); if(x) x.scrollIntoView({behavior:RM?'auto':'smooth'}); });

/* resume on the landing hero (lastStep is saved by goToStep) */
var resumeLink=$('#resumeLink');
if(resumeLink){
  var lastS=store.get('lastStep');
  if(typeof lastS==='number' && lastS>0 && lastS<TOTAL_STEPS-1){
    resumeLink.hidden=false;
    resumeLink.addEventListener('click',function(e){ e.preventDefault(); openExperience(true); goToStep(lastS); });
  }
}

/* deep link (2026-09-04, email serija): /pages/learn?ch=N ili #chN otvara seriju na poglavlju N */
(function(){
  try{
    var m=(location.search.match(/[?&]ch=(\d+)/)||location.hash.match(/^#ch(\d+)$/));
    var ch=m?parseInt(m[1],10):0;
    if(ch>=1 && ch<=TOTAL){ openExperience(true); jumpToChapter(ch); track('learn_deeplink',{chapter:ch}); }
  }catch(e){}
})();
/* init */
paintProgress(); onScroll();
})();